import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../common/Footer";
import NewNav from "../common/NewNav";

function MainLayout() {
  return (
    <div>
      <div className="sticky top-0 z-10  rounded-none">
        <NewNav />
      </div>

      <div className="">
        <Outlet></Outlet>
      </div>

      <Footer />
    </div>
  );
}

export default MainLayout;
